import Svg, { Path, type PathProps, type SvgProps } from 'react-native-svg'

export function TrashIcon({ svgProps, pathProps }: { svgProps?: SvgProps; pathProps?: PathProps }) {
  const width = svgProps?.width ?? 24
  const height = svgProps?.height ?? 24
  return (
    <Svg width={width} height={height} viewBox="0 0 24 24" fill="none" {...svgProps}>
      <Path
        d="M3 6h18M9 6V4a2 2 0 012-2h2a2 2 0 012 2v2m3 0v14a2 2 0 01-2 2H8a2 2 0 01-2-2V6h12z"
        stroke="#000"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        {...pathProps}
      />
    </Svg>
  )
}
